@if (input.case==='Default') {
  <div>
    <div style="outline-color: blue;">
      <div>
        <h1 class="title_center ">Dynamic Form</h1>
      </div>
      <div class="title_center"  > {{input.message }}</div>
      <div class="title_center">
        <div mat-dialog-actions style="float:right;margin:20px;">
          <button class="jss149 MuiButton-contained"  mat-button [mat-dialog-close]="{ clicked: 'Yes' }">Yes</button>
          <button  class="jss149 MuiButton-contained" mat-button  [mat-dialog-close]="{ clicked: 'No' }">
            No
          </button>
        </div></div>
      </div>
    </div>
  }
  @if (input.case==='Ok') {
    <div>
      <div class="confirm-container" style="outline-color: blue;">
        <h1 class="title_center ">Dynamic Form</h1>
        <div class="title_center"> {{input.message }}</div>
        <div class="title_center">
          <div mat-dialog-actions style="float:right;margin:20px;">
            <button class="jss149 MuiButton-contained" mat-button [mat-dialog-close]="{ clicked: 'Proceed' }">
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  }